<template>
  <div class="google-map mb-3 mt-0" ref="mapa"><i class="fas fa-car"></i></div>
</template>

<script>
import VehicleController from '../../controllers/VehicleController';
import GarageController from '../../controllers/GarageController';
import Constants from '../../models/constants/Constants.js';

export default {
  name: 'google-map-markers',

  props: {
    latitude: { type: String },
    longitude: { type: String },
  },

  data: function() {
    return {
      markers: [],
      vehicleController: new VehicleController(this.$resource),
      garageController: new GarageController(this.$resource),
      center: new google.maps.LatLng(-22.882672, -43.243438),
      url_bucket: Constants.URL_BUCKET_PICKNDRIVE,
    };
  },

  mounted: function() {
    this.initMap();
  },

  methods: {
    async initMap() {
      const element = this.$refs.mapa;
      const options = {
        zoom: 11,
        center: this.center,
        disableDefaultUI: true,
        gestureHandling: 'greedy',
        styles: [{ featureType: 'poi', stylers: [{ visibility: 'off' }] }],
      };
      const map = new google.maps.Map(element, options);
      await this.getsubFleetGarages();
      this.setMarkers(map);
    },

    async getsubFleetGarages() {
      let result = await this.garageController.subFleetGarages();
      this.markers = result;
      console.log('this.markers: ', this.markers);
    },

    setMarkers(map) {
      var bounds = new google.maps.LatLngBounds();

      const mIcon = {
        path: google.maps.SymbolPath.CIRCLE,
        fillOpacity: 1,
        fillColor: '#016ea7',
        strokeOpacity: 1,
        strokeWeight: 4,
        strokeColor: '#fff',
        scale: 20,
      };
      for (let mark of this.markers) {
        if (mark[0].latitude && mark[0].longitude) {
          let dataLatLng = new google.maps.LatLng({
            lat: mark[0].latitude,
            lng: mark[0].longitude,
          });
          bounds.extend(dataLatLng);

          //this.$refs.mapa.fitBounds(bounds);
        }
        let marker = new google.maps.Marker({
          position: new google.maps.LatLng(mark[0].latitude, mark[0].longitude),
          icon: mIcon,
          label: {
            color: '#fff',
            fontSize: '18px',
            fontWeight: '600',
            text: `${mark.length}`,
          },
          map: map,
          marker: mark,
        });

        marker.addListener('click', () => {
          this.$emit('selectedVehicle', marker);
        });
      }
    },
  },
};
</script>

<style scoped>
.google-map {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background: grey;
}
</style>
